import { Controller } from '@hotwired/stimulus';
import axios from "axios";
import {getMeta} from "../helpers";

export default class extends Controller {
  connect() {
    this.currentTimeout = null;
    this.formController = Stimulus.getControllerForElementAndIdentifier(this.element, 'axios-form');
    this.currentLanguageCode = getMeta('wp-language').split('-')[0];

    this.inputs = {
      type: this.element.querySelector('input[name="type"]'),
      appliedCouponCode: this.element.querySelector('input[name="applied_coupon_code"]'),
      contractID: this.element.querySelector('input[name="contract_id"]'),
      couponCode: this.element.querySelector('input[name="code"]'),
    };

    let debitDiscountSelector = this.inputs.contractID?.value
        ? `#debitDiscount-${this.inputs.contractID.value}`
        : '#debitDiscount';


    this.debitDiscount = this.element.querySelector(`${debitDiscountSelector}`);

    this.codeSubmitButton = this.element.querySelector('#codeSubmitButton');

    //Wait for coupon input and validate it
    if (this.inputs.couponCode && this.codeSubmitButton) {
      this.inputs.couponCode.addEventListener('input', (e) => {
        if (!e.target.value) {
          this.removeCouponError();
          this.debitDiscount.innerHTML = '';
          this.inputs.appliedCouponCode.value = '';
        }
      });

      this.codeSubmitButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.inputs.couponCode.value && this.inputs.appliedCouponCode.value !== this.inputs.couponCode) {
          this.validateCoupon(this.inputs.couponCode);
        }
      });
    }
  }

  removeCouponError() {
    const wrap = this.inputs.couponCode.parentNode.parentNode;
    this.inputs.couponCode.classList.remove('invalid');
    const inputError = wrap.querySelector('.input-error');
    if (inputError) {
      inputError.remove();
    }
  }

  resetCouponCode() {
    this.removeCouponError();
    this.inputs.couponCode.value = '';
    this.inputs.appliedCouponCode.value = '';
  }

  validateCoupon(input) {
    if (this.codeSubmitButton.classList.contains('loading')) {
      return;
    }

    this.codeSubmitButton.classList.add('loading');

    this.removeCouponError();
    this.inputs.couponCode.disabled = true;
    const url = '/wp-json/api/validate-coupon?rest_language=' + this.currentLanguageCode;

    let formData = new FormData;
    formData.append('code', input.value);
    formData.append('type', this.inputs.type.value);

    if (this.inputs.contractID?.value) {
      formData.append('contract_id', this.inputs.contractID.value);
    }

    this.formController.removeFormNotes();
    this.debitDiscount.innerHTML = '';

    axios.post(url, formData).then((response)=>{
      this.inputs.couponCode.disabled = false;
      this.codeSubmitButton.classList.remove('loading');
      response = response.data.data;

      if (response && response.errors && Object.keys(response.errors).length) {
        this.formController.setupFormErrors(response.errors);

      } else if (response && response.general_error) {
        this.formController.setupFormGeneralError(response);

      } else if (response && response.general_success) {
        this.formController.setupFormGeneralSuccess(response);

        if (input.value) {
          this.inputs.appliedCouponCode.value = input.value;
          console.log(response);

          if (response.type === 'debit-debt') {
            this.debitDiscount.innerHTML = `<span class="text-secondary">- ${response.off_total}</span> = ${response.total}`
          }
        }
      } else if (response && response.redirect) {
        window.location.href = response.redirect;

      } else if (response && response.reload) {
        window.location.reload();

      } else {
        if (!response || !response.action) {
          this.formController.setupFormUnexpectedError();
        }
      }
    })
  }
}
